interface InfoProps {
  label?: string
  text?: string | null
}

export const LineData = ({ label, text }: InfoProps) => {
  return (
    <div className="flex flex-col mb-6 mr-2 md:flex-row text-grey-800">
      <p className="mr-2">
        <span className="font-bold mr-1">{label}:</span>
        {text?.split('\n').map((textline, index) => (
          <span key={index}>
            {textline}
            <br />
          </span>
        ))}
      </p>
    </div>
  )
}
